import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import assets from 'modules/assets'

import Header from 'components/Utils/Header'
import Alert from 'components/Utils/Alert'
import AlertMini from 'components/Utils/AlertMini'
import Menu from 'components/Utils/Menu'
import Footer from 'components/Utils/Footer'

import HeaderGallery from 'components/Gallery/HeaderGallery'
import InfoGallery from 'components/Gallery/InfoGallery'
import MenuGallery from 'components/Gallery/MenuGallery'

class TopWrapper extends Component {
  constructor(props) {
    super(props)
    this.state = {...props}
  }
  componentWillReceiveProps(nextProps) {
    this.setState({...nextProps})
  }
  render() {
    let currentHeader = <Header alertIsMinimized={alert} scrollY={this.state.scrollY} {...this.props} />
    let currentMenu = <Menu />
    if (this.state.isNavigateGallery) {
      currentHeader = <HeaderGallery {...this.props}/>
      currentMenu = <MenuGallery {...this.props}/>
    }

    let headerStyle = {bottom: 'initial'}
    if (this.state.menuState) {
      headerStyle = {bottom: '0'}
    }

    return (
      <div>
        <div className="header-wrapper" style={headerStyle}>
          {currentMenu}
          <InfoGallery/>
        </div>
        <div >
          {currentHeader}
        </div>
      </div>
    )
  }
}
TopWrapper.contextTypes = {
}
TopWrapper.propTypes = {
}

function mapStateToProps(state, ownProps) {
  return {
    isNavigateGallery: state.token.isNavigateGallery,
    menuState: state.token.menuState
  }
}

export default connect(mapStateToProps)(TopWrapper)



// WEBPACK FOOTER //
// ./src/components/Utils/TopWrapper.js